import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SITELINK } from '../../app-routes/Links';
import { getFirstLetters, getUser } from '../../app-utils';
import { UserInterface } from '../../app-schemas/profile.schema';
import { Verify } from '../../assets/custom-icons';
import {  RiAccountPinCircleLine, RiBookmarkLine, 
  // RiGift2Line, 
  RiHeart3Line, RiLightbulbFlashLine, RiLogoutCircleLine, RiSearch2Line, 
  // RiSecurePaymentFill, 
  RiSignalTowerFill } from 'react-icons/ri';

interface NavProps {
  action: boolean;
  onClose?: () => void; // Add this prop to notify parent when closing
}

// main-component-ui
const PullOutNav = ({ action, onClose }: NavProps) => {
  const navigate = useNavigate();

  // gloabl state localstorage
  const user: UserInterface = getUser();
  const [isOpen, setIsOpen] = useState(false);

  // Sync with parent action prop
  useEffect(() => {
    setIsOpen(action);
  }, [action]);

  const closeSidebar = () => {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* pull out Sidebar */}
      <div>
        <div
          className={`fixed top-0 left-0 right-0 h-full w-3/4 bg-white dark:bg-neutral-600 shadow-lg z-[9999] text-white transform transition-transform duration-300 ${
            isOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          <nav className="p-4 bg-white dark:bg-neutral-600 pt-16">
            <ul>
              <li className="flex gap-3">
                <Link to={`${SITELINK.MY_PROFILE}/${user?.username}`} onClick={closeSidebar} className='flex items-center justify-center'>
                  <span className="block w-[40px] h-[40px] bg-[#223f64] rounded-full border border-green-100">
                    <h3 className="text-white text-[1.4rem] uppercase font-[600] relative top-0.5 left-2.5">
                      {getFirstLetters(user?.first_name ?? user?.username)}
                    </h3>
                  </span>
                </Link>

                <div className="text-sm">
                  <span className="gap-1 flex">
                    <span className="text-[16px] text-black dark:text-white font-bold madimi-one">
                      {user?.username}
                    </span>
                    <span>
                      {user?.is_verified && <img src={Verify} alt="" className="h-[12px]" />}
                    </span>
                  </span>
                  <span className="block text-[10px] text-[#8E8E8E] font-medium dark:text-white/80">
                    {user?.email}
                  </span>
                </div>
              </li>
            </ul>
          </nav>

          <nav className="p-4 text-gray-700 dark:text-white font-semibold text-sm overfloy-y-scroll pt-0">
            <ul className="space-y-1.5">
              <li className="">
                <Link
                  to={`${SITELINK.MY_PROFILE}/${user?.username}`}
                  className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100"
                  onClick={closeSidebar}
                >
                  <RiAccountPinCircleLine className="text-2xl" />
                  <span className="mt-1">Profile</span>
                </Link>
              </li>
              {/* <li className="mb-1">
                <Link 
                  to={SITELINK.SUBSCRIPTIONS} 
                  className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100"
                  onClick={closeSidebar}>
                  <RiGift2Line className="text-2xl" />
                  <span className="mt-1">Premium Services</span>
                </Link>
              </li>
              <li className="mb-1">
                <Link
                  to={SITELINK.MY_SUBSCRIPTION_HISTORY}
                  className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100"
                  onClick={closeSidebar}
                >
                  <RiSecurePaymentFill className="text-2xl" />
                  <span className="mt-1">Subscriptions</span>
                </Link>
              </li> */}
              <li className="mb-1">
                <Link 
                  to={SITELINK.MY_POSTS} 
                  className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100" 
                  onClick={closeSidebar}>
                  <RiSignalTowerFill className="text-2xl" />
                  <span className="mt-1">Posts</span>
                </Link>
              </li>
              <li className="mb-1 hidden">
                <Link 
                to={SITELINK.LIKED_POSTS} className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100 " onClick={closeSidebar}>
                  <RiHeart3Line className="text-2xl" />
                  <span className="mt-1">Liked Post</span>
                </Link>
              </li>
              <li className="mb-1">
                <Link to={SITELINK.BOOKMARKS} className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100" onClick={closeSidebar}>
                  <RiBookmarkLine className="text-2xl" />
                  <span className="mt-1">Saved</span>
                </Link>
              </li>
              <li className="mb-1">
                <Link to={SITELINK.BOOKMARKS} className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100" onClick={closeSidebar}>
                  <RiSearch2Line className="text-2xl" />
                  <span className="mt-1">Search</span>
                </Link>
              </li>
              <li className="mb-1">
                <Link to={SITELINK.MORE_COMMUNITIES} className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100" onClick={closeSidebar}>
                  <RiLightbulbFlashLine className="text-2xl" />
                  <span className="mt-1">Explore</span>
                </Link>
              </li>
              <li className="mb-1">
                <button
                  type="button"
                  onClick={() => {
                    localStorage.clear();
                    navigate(SITELINK.LOGIN);
                    closeSidebar();
                  }}
                  className="flex gap-4 p-3 hover:bg-gray-100 hover:dark:text-black rounded-full active:bg-gray-100 w-full text-left"
                >
                  <RiLogoutCircleLine className="text-2xl" />
                  <span className="mt-1">Logout</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>

        {/* Overlay */}
        {isOpen && (
          <div
            onClick={closeSidebar}
            className="fixed top-0 left-0 right-0 h-full w-full bg-[#00000042] shadow-lg z-40 text-white"
          ></div>
        )}
      </div>
    </>
  );
};

export default PullOutNav;